import { PassThroughThumbnailGetter } from "./ThumbnailGetter";
import { VimeoIdExtractor, VimeoThumbnailGetter } from "./Vimeo";
import {
  YoutubeIdExtractor,
  YoutubeShareLinkIdExtractor,
  YoutubeShareLinkThumbnailGetter,
  YoutubeThumbnailGetter,
} from "./Youtube";

export function thumbnailGetterFactory(url: string) {
  switch (true) {
    case YoutubeIdExtractor.is(url):
      return new YoutubeThumbnailGetter(url);
    case YoutubeShareLinkIdExtractor.is(url):
      return new YoutubeShareLinkThumbnailGetter(url);
    case VimeoIdExtractor.is(url):
      return new VimeoThumbnailGetter(url);
    default:
      return new PassThroughThumbnailGetter();
  }
}
